<template>
	<div>
		<van-popup v-model="showPopup" position="center" :close-on-click-overlay="true" :duration="0">
			<div v-if="imageUrl" class="wrapper" @touchmove.stop.prevent="() => { }">
				<div class="content">
					<div class="close_box" v-if="isShow">
						<img @click.stop.prevent="handleClose" class="close" src="@/assets/image/icon/tcclose.png" />
					</div>
					<img :src="imageUrl" @click.stop.prevent="handleClick" />
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { navigateUrl } from "@/utils/index.js"
import { clickAdPoint, clickAdShowLog, popouAD } from '@/api/common'
import { Popup, Toast } from 'vant'

export default {
	components: {
		[Popup.name]: Popup
	},
	props: {
		open: {
			type: Boolean,
			default: true,
		},
		place: {
			required: true,
			validator(value) {
				return ["index", "my", 'yun'].includes(value);
			},
		},
	},
	data() {
		return {
			imageUrl: "",
			interval: 0, // 触发弹窗的间隔，单位毫秒
			isShow: false,
			skipUrl: "", //跳转路径
			advertising: {},
			index: 0,
			showPopup: false
		};
	},
	computed: {
		storageKey() {
			return `popup-ad:${this.place}:open-timestamp`;
		},
	},
	watch: {
		open() {
			if (this.open) {
				this.doOpen();
			}
		},
	},
	mounted() {
		if (this.open) {
			this.doOpen();
		}
	},
	methods: {
		async doOpen() {
			await this.fetchImageFromServer();

			if (this.isCanOpen()) {
				this.saveNowTimestamp(); //打开的时候把此时出现的广告弹窗id 和 出现的时间存下来
				this.showPopup = true;
			} else {
				this.$emit('next', 0);
			}
		},
		async fetchImageFromServer() {
			try {
				const {
					code,
					data
				} = await popouAD({
					type: this.place
				});
				if (code === 200 && data.length > 0) {
					let id = localStorage.getItem(this.storageKey + 'id') || 0;
					this.index = data.findIndex(item => item.id == id);  //获取之前存储的id
					this.index++
					if (this.index > data.length - 1) {
						this.index = 0;
					}

					this.advertising = data[this.index] //当前展示的广告弹窗
					// 直接使用图片URL，移除uni.getImageInfo
					this.imageUrl = this.advertising.cover;
					this.skipUrl = this.advertising.url
					this.interval = this.advertising.pop_time * 60 * 60 * 1000;
					// this.interval = 10 * 1000;
					this.isShow = true
					if (this.advertising == '') {
						this.$emit('imageContent', false);
					} else {
						this.$emit('imageContent', true);
					}
				}
			} catch (error) {
				// noop
			}
		},
		//存储
		saveNowTimestamp() {
			localStorage.setItem(this.storageKey, Date.now());
			localStorage.setItem(this.storageKey + 'id', this.advertising.id);
		},
		isCanOpen() {
			// 没有图片
			if (!this.imageUrl) {
				return false;
			}
			// // 登录
			// if (!this.$store.getters.logged) {
			// 	return false;
			// }

			// 过期
			const timestamp = localStorage.getItem(this.storageKey) || 0; //之前弹窗出现存储的时间
			const isExpired = Date.now() > timestamp + this.interval;  //当前时间如果大于之前出现的时间加上弹窗的显示周期  就是过期
			if (!isExpired) {
				return false;
			}
			clickAdShowLog({ ad_id: this.advertising.id, show_type: 2 })

			return true;
		},
		handleClose() {
			this.showPopup = false;
			this.$emit("next", 2);
		},

		async handleClick() {
			if (!this.skipUrl) return;
			// 广告点击埋点
			try {
				await clickAdPoint({ ad_id: this.advertising.id, show_type: 2 })
			} catch (e) {
				//TODO handle the exception
			}
			navigateUrl(this.skipUrl, this.advertising.title, false)
			this.$emit("next", 1);
		},
		imgLoad() {
			this.isShow = true;
		},
	}
};
</script>

<style lang="scss" scoped>
.wrapper {
	width: 100vw;
	height: calc(var(--vh, 1vh) * 100);
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (min-width: 768px) {
		width: 70vw;
	}
}

.content {
	width: 100%;
	max-width: 80%;
	position: relative;
	display: flex;
	align-items: center;
	flex-direction: column;

	>img {
		display: block;
		width: auto;
		max-width: 300px;
    max-height: 70vh;
	}
}

.close_box {
	position: absolute;
	bottom: -2.55rem; // -102rpx / 40 = -2.55rem

	@media (min-width: 768px) {
		bottom: -2.5rem; // -100rpx / 40 = -2.5rem
	}

	z-index: 3;
	display: flex;
	flex-direction: row-reverse;

	.close {
		width: 1.15rem; // 46rpx / 40 = 1.15rem
		height: 1.15rem; // 46rpx / 40 = 1.15rem
	}
}
</style>